<div class="appContentsContainer">
  <form
    [formGroup]="dataCDT"
    (ngSubmit)="onSave()"
    class="formGroup container longDetail"
  >
    <h2 *ngIf="operation === 'creacion'">
      {{ "dataCDT.titleCreate" | translate }}
    </h2>
    <h2 *ngIf="operation === 'edicion'">
      {{ "dataCDT.titleEdit" | translate }}
    </h2>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.datosCabecera"
        class="submitSearchButton"
        (click)="sectionHidden.datosCabecera = !sectionHidden.datosCabecera"
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.datosCabecera"
        class="submitSearchButton"
        (click)="sectionHidden.datosCabecera = !sectionHidden.datosCabecera"
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle withButton">Datos Cabecera</div>
    </div>

    <div class="halfGroup" *ngIf="!sectionHidden.datosCabecera">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTipo" for="daTipo">Tipo</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daTipo"
              maxlength="10"
              [readonly]="operation === 'edicion'"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daVariante" for="daVariante">Variante</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daVariante"
              maxlength="25"
              [readonly]="operation === 'edicion'"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daVersion" for="daVersion">Versión</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daVersion"
              maxlength="35"
              [readonly]="operation === 'edicion'"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="daContrasenya">Contraseña</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="daContrasenya"
              type="text"
              formControlName="daContrasenya"
              maxlength="25"
              [readonly]="operation === 'edicion'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.datosCarroceria"
        class="submitSearchButton"
        (click)="sectionHidden.datosCarroceria = !sectionHidden.datosCarroceria"
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.datosCarroceria"
        class="submitSearchButton"
        (click)="sectionHidden.datosCarroceria = !sectionHidden.datosCarroceria"
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle withButton">Datos carrocería</div>
    </div>

    <div class="halfGroup" *ngIf="!sectionHidden.datosCarroceria">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTcarroceria" for="daTcarroceria"
                >Tipo carrocería</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daTcarroceria" maxlength="2" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTcarroceriaDesc" for="daTcarroceriaDesc"
                >Desc.carrocería</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daTcarroceriaDesc"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daLongitudMin" for="daLongitudMin"
                >Longitud(mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daLongitudMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daLongitudMax" for="daLongitudMax"
                >Longitud(máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daLongitudMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAnchuraMin" for="daAnchuraMin">Anchura(mín)</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daAnchuraMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAnchuraMax" for="daAnchuraMax">Anchura(máx)</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daAnchuraMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daNumPuertas" for="daNumPuertas">Núm. puertas</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daNumPuertas" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAlturaMin" for="daAlturaMin">Altura(mín)</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daAlturaMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAlturaMax" for="daAlturaMax">Altura(máx)</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daAlturaMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daLongitudMaximaAdmMin" for="daLongitudMaximaAdmMin"
                >Long. carrozable(mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daLongitudMaximaAdmMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daLongitudMaximaAdmMax" for="daLongitudMaximaAdmMax"
                >Long. carrozable(máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daLongitudMaximaAdmMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daNumeroPlazasAsiento" for="daNumeroPlazasAsiento"
                >Núm. asientos
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daNumeroPlazasAsiento" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daDispositivosAlumbrado" for="daDispositivosAlumbrado"
                >Num. proyectores alumbrado</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daDispositivosAlumbrado" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daVoladizoTraseroMin" for="daVoladizoTraseroMin"
                >Voladizo trasero(mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daVoladizoTraseroMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daVoladizoTraseroMax" for="daVoladizoTraseroMax"
                >Voladizo trasero(máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daVoladizoTraseroMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daVoladMaxPostCarr" for="daVoladMaxPostCarr"
                >Vol. máx. carrozable</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daVoladMaxPostCarr" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daNumAsientosSinConduc" for="daNumAsientosSinConduc"
                >N.Asientos(s/conduc)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daNumAsientosSinConduc" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daCapacidadDeposito" for="daCapacidadDeposito"
                >Capacidad deposito</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daCapacidadDeposito" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daNumDepositos" for="daNumDepositos"
                >Número depósitos</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daNumDepositos" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daVolumenBodega" for="daVolumenBodega"
                >Volumen bodega</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daVolumenBodega"
              maxlength="20"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAnchoMaxCarr" for="daAnchoMaxCarr"
                >Ancho máx. carrozable</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daAnchoMaxCarr"
              maxlength="11"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daDispPuertas" for="daDispPuertas"
                >Disposición puertas</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daDispPuertas" maxlength="50" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMarcaHomolDispEng" for="daMarcaHomolDispEng"
                >Marca homol. disp. enganche</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daMarcaHomolDispEng"
              maxlength="50"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daEmplazAsientos" for="daEmplazAsientos"
                >Emplazamiento asientos</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daEmplazAsientos"
              maxlength="50"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMarcaHomolCeDispEng" for="daMarcaHomolCeDispEng"
                >Marca homol.CE disp. enganche</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daMarcaHomolCeDispEng"
              maxlength="50"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.direccionSuspensionFrenos"
        class="submitSearchButton"
        (click)="
          sectionHidden.direccionSuspensionFrenos =
            !sectionHidden.direccionSuspensionFrenos
        "
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.direccionSuspensionFrenos"
        class="submitSearchButton"
        (click)="
          sectionHidden.direccionSuspensionFrenos =
            !sectionHidden.direccionSuspensionFrenos
        "
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle withButton">Dirección, suspensión y frenos</div>
    </div>

    <div class="halfGroup" *ngIf="!sectionHidden.direccionSuspensionFrenos">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daDireccion" for="daDireccion">Dirección</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daDireccion" maxlength="50" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daBarraSuspDelante" for="daBarraSuspDelante"
                >Suspensión barra estab. delante</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daBarraSuspDelante"
              maxlength="3"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daDispositivoFrenado" for="daDispositivoFrenado"
                >Dispositivo de frenado</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <textarea
              formControlName="daDispositivoFrenado"
              maxlength="250"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAsistencia" for="daAsistencia"
                >Método de asistencia</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daAsistencia" maxlength="50" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daBarraSuspTrasera" for="daBarraSuspTrasera"
                >Suspensión barra estab. atrás</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daBarraSuspTrasera"
              maxlength="3"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="collapseButtonContainer">
        <button
          type="button"
          *ngIf="!sectionHidden.ejesYruedas"
          class="submitSearchButton"
          (click)="sectionHidden.ejesYruedas = !sectionHidden.ejesYruedas"
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          type="button"
          *ngIf="sectionHidden.ejesYruedas"
          class="submitSearchButton"
          (click)="sectionHidden.ejesYruedas = !sectionHidden.ejesYruedas"
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <div class="pageTitle withButton">Ejes y ruedas</div>
      </div>

      <div class="halfGroup" *ngIf="!sectionHidden.ejesYruedas">
        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daDistanciaEjes" for="daDistanciaEjes"
                  >Distancia ejes 1 y 2</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daDistanciaEjes" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daDistanciaEjes23" for="daDistanciaEjes23"
                  >Distancia ejes 2 y 3</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daDistanciaEjes23" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daDistanciaEjes5Ult" for="daDistanciaEjes5Ult"
                  >Avance 5ª rueda</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daDistanciaEjes5Ult" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daViaEjeAnteriorMin" for="daViaEjeAnteriorMin"
                  >Vía eje 1 (mín)</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daViaEjeAnteriorMin" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daViaEjeAnteriorMax" for="daViaEjeAnteriorMax"
                  >Vía eje 1 (máx)</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daViaEjeAnteriorMax" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daViaEjePosteriorMin" for="daViaEjePosteriorin"
                  >Vía eje 2 (mín)</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daViaEjePosteriorMin" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daViaEjePosteriorMax" for="daViaEjePosteriorMax"
                  >Vía eje 2 (máx)</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daViaEjePosteriorMax" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEjes" for="daEjes">Número ejes</label>
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEjes" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daRuedas" for="daRuedas">Número ruedas</label>
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daRuedas" />
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daNeumaticosAnterior" for="daNeumaticosAnterior"
                  >Neumáticos eje 1</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <textarea
                formControlName="daNeumaticosAnterior"
                maxlength="250"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daNeumaticosPosterior" for="daNeumaticosPosterior"
                  >Neumáticos eje 2</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <textarea
                formControlName="daNeumaticosPosterior"
                maxlength="250"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEjesMotores" for="daEjesMotores"
                  >Ejes motores</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daEjesMotores"
                maxlength="30"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daLlantasAnterior" for="daLlantasAnterior"
                  >Ruedas eje 1</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <textarea
                formControlName="daLlantasAnterior"
                maxlength="250"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daLlantasPosterior" for="daLlantasPosterior"
                  >Ruedas eje 2</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <textarea
                formControlName="daLlantasPosterior"
                maxlength="250"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daRuedasGemelas" for="daRuedasGemelas"
                  >Núm. y pos. ejes ruedas gemelas</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daRuedasGemelas"
                maxlength="50"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="collapseButtonContainer">
        <button
          type="button"
          *ngIf="!sectionHidden.emisisionesCo2Consumo"
          class="submitSearchButton"
          (click)="
            sectionHidden.emisisionesCo2Consumo =
              !sectionHidden.emisisionesCo2Consumo
          "
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          type="button"
          *ngIf="sectionHidden.emisisionesCo2Consumo"
          class="submitSearchButton"
          (click)="
            sectionHidden.emisisionesCo2Consumo =
              !sectionHidden.emisisionesCo2Consumo
          "
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <div class="pageTitle withButton">Emisiones CO2/Consumo</div>
      </div>

      <div class="halfGroup" *ngIf="!sectionHidden.emisisionesCo2Consumo">
        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daConsumoNumDirBase" for="daConsumoNumDirBase"
                  >Núm. directiva base</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daConsumoNumDirBase"
                maxlength="20"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daConsumoUltVersDir" for="daConsumoUltVersDir"
                  >Últ. directiva base</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daConsumoUltVersDir"
                maxlength="20"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmisionesUrbanas" for="daEmisionesUrbanas"
                  >Ciclo. urb. CO2 g/km</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEmisionesUrbanas" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daConsumoUrbano" for="daConsumoUrbano"
                  >Ciclo. urb. consumos</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daConsumoUrbano" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmisionesExtraurb" for="daEmisionesExtraurb"
                  >Carretera CO2 g/km</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEmisionesExtraurb" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daConsumoExtraurb" for="daConsumoExtraurb"
                  >Carretera consumos</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daConsumoExtraurb" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmisionCo2" for="daEmisionCo2"
                  >Mixto CO2 g/km</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEmisionCo2" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daConsumoCombi" for="daConsumoCombi"
                  >Mixto consumos g/km</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daConsumoCombi" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daNivelEmisiones" for="daNivelEmisiones"
                  >Nivel emisiones</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daNivelEmisiones"
                maxlength="10"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daHumos" for="daHumos">Humos diésel</label>
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daHumos" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daIndEcoinnovacion" for="daIndEcoinnovacion"
                  >Indicador Ecoinnocación</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daIndEcoinnovacion"
                maxlength="1"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daTextoEcoinn" for="daTextoEcoinn"
                  >Código Ecoinnocación</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daTextoEcoinn"
                maxlength="4"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daAhorroCo2Diesel" for="daAhorroCo2Diesel"
                  >Ahorro CO2 Diesel (Reduc. Ecnoinnov.)</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daAhorroCo2Diesel"
                maxlength="5"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daAhorroCo2Gas" for="daAhorroCo2Gas"
                  >Ahorro CO2 Gas (Reduc. Ecnoinnov.)</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daAhorroCo2Gas"
                maxlength="5"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daAhorroCo2Otros" for="daAhorroCo2Otros"
                  >Ahorro CO2 Otros (Reduc. Ecnoinnov.)</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daAhorroCo2Otros"
                maxlength="5"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="collapseButtonContainer">
        <button
          type="button"
          *ngIf="!sectionHidden.emisionesEscape"
          class="submitSearchButton"
          (click)="
            sectionHidden.emisionesEscape = !sectionHidden.emisionesEscape
          "
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          type="button"
          *ngIf="sectionHidden.emisionesEscape"
          class="submitSearchButton"
          (click)="
            sectionHidden.emisionesEscape = !sectionHidden.emisionesEscape
          "
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <div class="pageTitle withButton">Emisiones - Escape</div>
      </div>

      <div class="halfGroup" *ngIf="!sectionHidden.emisionesEscape">
        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmiEscapeEnsayo1" for="daEmiEscapeEnsayo1"
                  >Procedimiento ensayo 1</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daEmiEscapeEnsayo1"
                maxlength="50"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmiEscapeNumDirBase" for="daEmiEscapeNumDirBase"
                  >Núm. directiva base</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daEmiEscapeNumDirBase"
                maxlength="15"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmiEscapeUltVersDir" for="daEmiEscapeUltVersDir"
                  >Última vers. directiva base</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daEmiEscapeUltVersDir"
                maxlength="15"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmiEscapeFaseAplic" for="daEmiEscapeFaseAplic"
                  >Fase aplicación</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daEmiEscapeFaseAplic"
                maxlength="2"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo1Co" for="daEscapeEnsayo1Co"
                  >1 - Emisión CO</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo1Co" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo1Hc" for="daEscapeEnsayo1Hc"
                  >1 - Emisión HC</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo1Hc" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo1Nox" for="daEscapeEnsayo1Nox"
                  >1 - Emisión NOX</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo1Nox" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo1Hcnox" for="daEscapeEnsayo1Hcnox"
                  >1 - Emisión HC + NOX</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo1Hcnox" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo1Humo" for="daEscapeEnsayo1Humo"
                  >1 - Emisión humo</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo1Humo" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo1Partic" for="daEscapeEnsayo1Partic"
                  >1 - Emisión partículas</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo1Partic" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEmiEscapeEnsayo2" for="daEmiEscapeEnsayo2"
                  >Procedimiento ensayo 2</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daEmiEscapeEnsayo2"
                maxlength="50"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo2Co" for="daEscapeEnsayo2Co"
                  >2 - Emisión CO</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo2Co" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo2Hc" for="daEscapeEnsayo2Hc"
                  >2 - Emisión HC</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo2Hc" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo2Nox" for="daEscapeEnsayo2Nox"
                  >2 - Emisión NOX</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo2Nox" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo2Hcnox" for="daEscapeEnsayo2Hcnox"
                  >2 - Emisión HC + NOX</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo2Hcnox" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo2Humo" for="daEscapeEnsayo2Humo"
                  >2 - Emisión humo</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo2Humo" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daEscapeEnsayo2Partic" for="daEscapeEnsayo2Partic"
                  >2 - Emisión partículas</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="number" formControlName="daEscapeEnsayo2Partic" />
            </div>
          </div>
        </div>
      </div>

      <div class="collapseButtonContainer">
        <button
          type="button"
          *ngIf="!sectionHidden.datosGenerales"
          class="submitSearchButton"
          (click)="sectionHidden.datosGenerales = !sectionHidden.datosGenerales"
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          type="button"
          *ngIf="sectionHidden.datosGenerales"
          class="submitSearchButton"
          (click)="sectionHidden.datosGenerales = !sectionHidden.datosGenerales"
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <div class="pageTitle withButton">Datos generales</div>
      </div>

      <div class="halfGroup" *ngIf="!sectionHidden.datosGenerales">
        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daMarca" for="daMarca">Marca</label>
              </div>
            </div>
            <div class="inputContainer">
              <input type="text" formControlName="daMarca" maxlength="25" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daContrasenaGnc" for="daContrasenaGnc"
                  >Contraseña GNC</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daContrasenaGnc"
                maxlength="20"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daAutoridadGnc" for="daAutoridadGnc"
                  >Autoridad GNC</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daAutoridadGnc"
                maxlength="3"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daExtension" for="daExtension">Extensión</label>
              </div>
            </div>
            <div class="inputContainer">
              <input type="text" formControlName="daExtension" maxlength="2" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daParteFijaVin" for="daParteFijaVin"
                  >Parte fija VIN</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daParteFijaVin"
                maxlength="17"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daProcedencia" for="daProcedencia"
                  >Procedencia</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daProcedencia"
                maxlength="5"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daClasificVehiculo" for="daClasificVehiculo"
                  >Clasificación</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daClasificVehiculo"
                maxlength="10"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daCategoria" for="daCategoria">Categoría</label>
              </div>
            </div>
            <div class="inputContainer">
              <input type="text" formControlName="daCategoria" maxlength="10" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daFechaHomologacion" for="daFechaHomologacion"
                  >Fecha homologación</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="date" formControlName="daFechaHomologacion" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daDenominacion" for="daDenominacion"
                  >Denominación</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daDenominacion"
                maxlength="65"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daNomFabBase" for="daNomFabBase"
                  >Nombre fab. vehículo</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daNomFabBase"
                maxlength="50"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daDirFabBase" for="daDirFabBase"
                  >Dirección fab. vehículo</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input
                type="text"
                formControlName="daDirFabBase"
                maxlength="100"
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daObsFamilia" for="daObsFamilia"
                  >Observaciones</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <textarea
                formControlName="daObsFamilia"
                maxlength="250"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="daObsOpcHomol" id="daObsOpcHomol"
                  >Opciones incluidas en homologación de tipo</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <textarea
                formControlName="daObsOpcHomol"
                maxlength="250"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daCodigocdt" for="daCodigocdt">Código CDT</label>
              </div>
            </div>
            <div class="inputContainer">
              <input type="text" formControlName="daCodigocdt" maxlength="60" />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daNomFabUlt" for="daNomFabUlt"
                  >Nombre fab. vehiculo últ. fase</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <input type="text" formControlName="daNomFabUlt" maxlength="50" />
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daDirFabUlt" for="daDirFabUlt"
                  >Dirección fab. vehículo últ. fase</label
                >
              </div>
            </div>
            <div class="inputContainer">
              <textarea
                formControlName="daDirFabUlt"
                maxlength="100"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row compressedRow longListTextarea">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="daObsCoc" for="daObsCoc">Observaciones COC</label>
              </div>
            </div>
            <div class="inputContainer">
              <textarea formControlName="daObsCoc" maxlength="250"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.masas"
        class="submitSearchButton"
        (click)="sectionHidden.masas = !sectionHidden.masas"
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.masas"
        class="submitSearchButton"
        (click)="sectionHidden.masas = !sectionHidden.masas"
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle withButton">Masas</div>
    </div>

    <div class="halfGroup" *ngIf="!sectionHidden.masas">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMomMin" for="daMomMin"
                >Condiciones de marcha en KG(mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMomMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMomMax" for="daMomMax"
                >Condiciones de marcha en KG(máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMomMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta1Min" for="daMmta1Min"
                >Máx. téc. admisible eje 1 carga (mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta1Min" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta1Max" for="daMmta1Max"
                >Máx. téc. admisible eje 1 carga (máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta1Max" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta2Min" for="daMmta2Min"
                >Máx. téc. admisible eje 2 carga (mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta2Min" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta2Max" for="daMmta2Max"
                >Máx. téc. admisible eje 2 carga (máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta2Max" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmrBarraTraccion" for="daMmrBarraTraccion"
                >Máx. remolc. téc. admis. barra tracc.</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmrBarraTraccion" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmtaMin" for="daMmtaMin"
                >Máx. técnica. admisible en KG (mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmtaMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmtaMax" for="daMmtaMax"
                >Máx. técnica. admisible en KG (máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmtaMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta1Min" for="daMmta1Min"
                >Máx. autorizada eje 1 (mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta1Min" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta1Max" for="daMmta1Max"
                >Máx. autorizada eje 1 (máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta1Max" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta2Min" for="daMmta2Min"
                >Máx. autorizada eje 2 (mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta2Min" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmta2Max" for="daMmta2Max"
                >Máx. autorizada eje 2 (máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmta2Max" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmrSinFrenos" for="daMmrSinFrenos"
                >Máx. téc. admis. remolque sin frenos</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daMmrSinFrenos" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmtcMin" for="daMmtcMin"
                >Máx. téc. admis. conjunto(mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmtcMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmtcMax" for="daMmtcMax"
                >Máx. téc. admis. conjunto(máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmtcMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmrConFrenos" for="daMmrConFrenos"
                >Máx. remolc. téc. admis. con frenos</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmrConFrenos" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmrSemiremolque" for="daMmrSemiremolque"
                >Máx. remolc. téc. admis. semirremol.</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmrSemiremolque" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daCargaPtoEnganCent" for="daCargaPtoEnganCent"
                >Carga pto. engan. remol. eje central</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daCargaPtoEnganCent"
              maxlength="11"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmtaConjunto" for="daMmtaConjunto"
                >Máx. técnic admis. conjunto</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daMmtaConjunto"
              maxlength="11"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmaMin" for="daMmaMin">Máxima autorizada(mín)</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmaMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmaMax" for="daMmaMax">Máxima autorizada(máx)</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmaMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmacMin" for="daMmacMin"
                >Máx. autorizada conjunto(mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmacMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daMmacMax" for="daMmacMax"
                >Máx. autorizada conjunto(máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMmacMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label
                id="daMasaMinimaAdmisibleMin"
                for="daMasaMinimaAdmisibleMin"
                >Mín. Admis. vehíc. completado(mín)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMasaMinimaAdmisibleMin" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label
                id="daMasaMinimaAdmisibleMax"
                for="daMasaMinimaAdmisibleMax"
                >Mín. Admis. vehíc. completado(máx)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daMasaMinimaAdmisibleMax" />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.motorGeneral"
        class="submitSearchButton"
        (click)="sectionHidden.motorGeneral = !sectionHidden.motorGeneral"
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.motorGeneral"
        class="submitSearchButton"
        (click)="sectionHidden.motorGeneral = !sectionHidden.motorGeneral"
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle withButton">Motor - General</div>
    </div>

    <div class="halfGroup" *ngIf="!sectionHidden.motorGeneral">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTmotor" for="daTmotor">Código motor</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daTmotor" maxlength="4" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daNumeroCilindros" for="daNumeroCilindros"
                >Número cilindros</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daNumeroCilindros" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daPotencia" for="daPotencia">Potencia máxima KW</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daPotencia" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daPotNominalKw" for="daPotNominalKw"
                >Potencia nom. KW</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daPotNominalKw" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daCodigoMotor" for="daCodigoMotor"
                >Código motor / N.Ident.</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daCodigoMotor" maxlength="20" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daDisposicionCilindros" for="daDisposicionCilindros"
                >Disposición cilindros</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daDisposicionCilindros"
              maxlength="15"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daRegimenGiroPotMax" for="daRegimenGiroPotMax"
                >Régimen potencia máx.</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daRegimenGiroPotMax" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daPotenciaNominal" for="daPotenciaNominal"
                >Potencia eléctricos</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daPotenciaNominal" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daInyeccDirecta" for="daInyeccDirecta"
                >Inyección directa</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daInyeccDirecta"
              maxlength="3"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daCilindrada" for="daCilindrada"
                >Cilindrada en CM3</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daCilindrada" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daVelocidadMaxima" for="daVelocidadMaxima"
                >Velocidad máx. KM/H</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daVelocidadMaxima" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAlimCombustible" for="daAlimCombustible"
                >Alimentación + combustible</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daAlimCombustible"
              maxlength="4"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daConsumoElectrico" for="daConsumoElectrico"
                >Consumo eléctrico</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daConsumoElectrico"
              maxlength="6"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daCombustible" for="daCombustible"
                >Combustible / Fuente energía</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daCombustible" maxlength="30" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTipoVehiElec" for="daTipoVehiElec"
                >Tipo vehíc. eléctrico</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daTipoVehiElec" maxlength="4" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daAutonomiaElectrica" for="daAutonomiaElectrica"
                >Autonomía eléctrica</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daAutonomiaElectrica"
              maxlength="6"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daPrincipioMotor" for="daPrincipioMotor"
                >Principio funcionamiento motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daPrincipioMotor"
              maxlength="50"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daRpmCorte" for="daRpmCorte">RPM corte de bomba</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daRpmCorte" maxlength="40" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daFabMarcaMotor" for="daFabMarcaMotor"
                >Fabricante / Marca motor</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daFabMarcaMotor"
              maxlength="25"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.motorNivelSonido"
        class="submitSearchButton"
        (click)="
          sectionHidden.motorNivelSonido = !sectionHidden.motorNivelSonido
        "
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.motorNivelSonido"
        class="submitSearchButton"
        (click)="
          sectionHidden.motorNivelSonido = !sectionHidden.motorNivelSonido
        "
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle withButton">Motor - Nivel de ruido</div>
    </div>

    <div class="halfGroup" *ngIf="!sectionHidden.motorNivelSonido">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daNivelRuidoParadoU1" for="daNivelRuidoParadoU1"
                >RPM motor al medir nivel</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daNivelRuidoParadoU1" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daNivelRuidoParadoU2" for="daNivelRuidoParadoU2"
                >Parado, en db(A)</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="daNivelRuidoParadoU2" />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.transmision"
        class="submitSearchButton"
        (click)="sectionHidden.transmision = !sectionHidden.transmision"
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.transmision"
        class="submitSearchButton"
        (click)="sectionHidden.transmision = !sectionHidden.transmision"
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle withButton">Transmisión</div>
    </div>

    <div class="halfGroup" *ngIf="!sectionHidden.transmision">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daCajaCambios" for="daCajaCambios"
                >Tipo caja cambios</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daCajaCambios" maxlength="16" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTipoEmbrague" for="daTipoEmbrague"
                >Tipo embrague</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="daTipoEmbrague"
              maxlength="50"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTraccion" for="daTraccion">Tipo tracción</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daTraccion" maxlength="10" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTcambio" for="daTcambio">Tipo cambio</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daTcambio" maxlength="3" />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="daTipoCaja" for="daTipoCaja">Tipo caja</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="daTipoCaja" maxlength="50" />
          </div>
        </div>
      </div>
    </div>

    <div class="halfGroup">
      <div
        class="formGroupButtons detalleFormGroupButtonsFooter longDetailFooter"
      >
        <div class="formButton">
          <button
            class="submitButton"
            *ngIf="dataCDT.pristine"
            type="button"
            (click)="goList()"
          >
            <em class="fas fa-caret-square-left"></em>
          </button>
          <button
            class="submitButton"
            *ngIf="!dataCDT.pristine"
            type="button"
            [swal]="confirmSwal"
          >
            <em class="fas fa-caret-square-left"></em>
          </button>
        </div>

        <div class="middleButtonAceptarContainer notFullWidth">
          <div class="formButton">
            <button class="submitButton wideSubmitButton" type="submit">
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>

        <swal
          #confirmSwal
          html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
          icon="warning"
          [showCancelButton]="true"
          [swalOptions]="{
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            allowEscapeKey: false,
            allowOutsideClick: false
          }"
          [focusCancel]="true"
          (confirm)="goList()"
        >
        </swal>
      </div>
    </div>
  </form>
</div>
